import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslationValue} from '../../../generated/sales-terminal-client';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss']
})
export class LinkComponent {
  @Input() public link: TranslationValue[] | string | number;
  @Input() public icon: string;
  @Input() public disabled: boolean;
  @Input() public wrap: boolean;
  @Input() public inlineFlex: boolean;
  @Input() public blankTarget: boolean;
  @Input() public linkClass: string;
  @Input() public navigationIcon: boolean;
  @Input() public mobileHeading: boolean;
  @Input() public textAddition: boolean;

  @Output() public linkClicked: EventEmitter<any> = new EventEmitter<any>();

  public emitClick(): void {
    if (this.disabled) return;
    this.linkClicked.emit();
  }
}
